module.exports = __webpack_public_path__ + "media/entities/1612-4fc5790d.png";